module.exports = __webpack_public_path__ + "img/06.b3940e04.jpg";